import { libnumber_exporter } from '../../../libraries/libnumber_exporter';
import { sortItems } from '../../../libraries/sortItems';
import { turpial } from '../../../libraries/turpial';


class FecthLocationIpAndSprites
{
    static locationData = null;
    static data = null;
    static sprites = null;
    static countries = null;
    static countries_backup = null;
    static selected_code = null;
    static selected_country = null;
    static selected_dial = null;
    static async get()
    {
                
        let trace = "https://www.cloudflare.com/cdn-cgi/trace";

        if(window.location.host.search("my3pod.com") >= 0){
            trace = "https://my3pod.com/cdn-cgi/trace"
        }
        if(window.location.host.search("3pod.io") >= 0){
            trace = "https://3pod.io/cdn-cgi/trace"
        }

        return new Promise((resolve, reject)=>{
            if(FecthLocationIpAndSprites.data !== null){
                resolve({
                    locationData: FecthLocationIpAndSprites.locationData,
                    data: FecthLocationIpAndSprites.data,
                    sprites: FecthLocationIpAndSprites.sprites,
                    countries: FecthLocationIpAndSprites.countries,
                    countries_backup: FecthLocationIpAndSprites.countries_backup,
                });
                return;
            }

            turpial.fetch({
                method: "GET",
                type: "text",
                url: [
                    "https://cdn.jsdelivr.net/gh/Yerikmiller/yerikmiller.github.io@latest/countries_flags_emoji/countries.json",
                    "https://cdn.jsdelivr.net/gh/Yerikmiller/yerikmiller.github.io/countries_flags_emoji/sprites.svg",
                    trace,
                ],
                ready: (data)=>{
                    let locationData = data[2];
                    let sprites = data[1];
                    data = JSON.parse(data[0]);
    
                    let countries = data.data;
                    countries = sortItems(countries, "n", "asc");
                    let countries_backup = countries;

                    FecthLocationIpAndSprites.locationData = locationData; 
                    FecthLocationIpAndSprites.data = data; 
                    FecthLocationIpAndSprites.sprites = sprites; 
                    FecthLocationIpAndSprites.countries = countries; 
                    FecthLocationIpAndSprites.countries_backup = countries_backup; 

                    libnumber_exporter(function(){
                        resolve({
                            locationData: locationData,
                            data: data,
                            sprites: sprites,
                            countries: countries,
                            countries_backup: countries_backup,
                        })
                    })
                }
            })
        });
    }
    static async getByTimezone()
    {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const body = await fetch("https://cdn.jsdelivr.net/gh/3pod-us/3pod-us.github.io@master/timezones_countries.json")
        const timezones = await body.json();
        const location = timezones[timezone] ?? null;
        if(location === null){
            return "CO"
        }

        return location;
    }
}

export {FecthLocationIpAndSprites}